import React, { Component } from 'react';
import { DefaultButton, PrimaryButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { MessageBars } from '../Outils/MessageBars';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import './FicheFinancement.css';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataFinancement } from '../../data/DataFinancement.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    peutAjouterBlocFinancement
    peutModifierBlocFinancement
    peutSupprimerBlocFinancement

    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    financement: {},
    listFinancements: [],

    onActiveLesChampsDuFormulaire: false,
    onActiveBoutonEnregistrer: false,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    //peutModifierBlocFinancement: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    titrePanelFinancement: 'Ajouter un financement',

    onActiveBoutonEnregistrer: false,

};

export class FicheFinancement extends Component {
    _creationContent() {
        return (
            <Panel
                isOpen={this.props.onAffichePanelFinancement}
                headerText={this.state.titrePanelFinancement}
                type={PanelType.large}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className="ms-Grid containerFinancement" dir="ltr">
                    {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                    <div className="ms-Grid-row">
                        <MessageBars
                            errorMessage={this.state.errorMessage}
                            warningMessage={this.state.warningMessage}
                            onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                            onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                        />
                    </div>

                    <div className="ms-Grid-row blocTotauxSuiviCompteClient">
                        <div className="ms-Grid-col ms-sm12 ms-xl6" />
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <span className="labelPretFinancement">{this.state.listFinancements.length > 0 ? `Avec prêt : ${this.state.listFinancements.length} enregistrement(s)` : `Sans prêt`}</span>
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-xl6 blocFinancement">
                            <div className="ms-Grid-row">
                                <div className="titreBlocFinancement">Financement</div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" name="divPret">
                                    <Toggle
                                        label="Financement avec prêt ?"
                                        checked={this.state.onActiveLesChampsDuFormulaire}
                                        onText="Avec prêt"
                                        offText="Sans prêt"
                                        inlineLabel
                                        onChange={(e, isChecked) => this.setState({ onActiveLesChampsDuFormulaire: isChecked })}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6 ms-xxl6 ms-xxxl6" name="divMode">
                                    <EUIComboBox
                                        disabled={!this.state.onActiveLesChampsDuFormulaire}
                                        idValeurParDefaut="0"
                                        label="Mode"
                                        onChange={(event, option) => this._onMiseAJourChamp("financement", "naturePret", option.key)}
                                        options={[
                                            { key: "PPI", text: "PPI" },
                                            { key: "PEL", text: "PEL" },
                                            { key: "Prêt relais", text: "Prêt relais" },
                                            { key: "PTZ", text: "PTZ" },
                                            { key: "Autre", text: "Autre" }
                                        ]}
                                        required={this.state.onActiveLesChampsDuFormulaire}
                                        selectedKey={this.state.financement.naturePret}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6 ms-xxl6 ms-xxxl6" name="divMontantMax">
                                    <TextField // Note KP : TextFieldNombre en cours de test
                                        label="Montant total maximum"
                                        disabled={!this.state.onActiveLesChampsDuFormulaire}
                                        required={this.state.onActiveLesChampsDuFormulaire}
                                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'financement', 'montantTotalMax', false, 2)}
                                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'financement', 'montantTotalMax', this._onVerificationFormulaire)}
                                        onBlur={e => this._onMiseAJourChampNombre("financement", "montantTotalMax", e.target.value, this._onVerificationFormulaire)}
                                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'montantTotalMax', e, false, 2)}
                                        deferredValidationTime={0}
                                        suffix="€"
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6 ms-xxl6 ms-xxxl6" name="divDureeMin">
                                    <TextField // Note KP : TextFieldNombre en cours de test
                                        label="Durée minimale"
                                        disabled={!this.state.onActiveLesChampsDuFormulaire}
                                        required={this.state.onActiveLesChampsDuFormulaire}
                                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'financement', 'dureeMinimale', false, 0)}
                                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'financement', 'dureeMinimale', this._onVerificationFormulaire)}
                                        onBlur={e => this._onMiseAJourChampNombre("financement", "dureeMinimale", e.target.value, this._onVerificationFormulaire)}
                                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'dureeMinimale', e, false, 0)}
                                        deferredValidationTime={0}
                                        suffix="années"
                                    />
                                </div>
                                {this.state.financement.naturePret !== "PTZ" ? ( //MG: 2367
                                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6 ms-xxl6 ms-xxxl6" name="divTaux">
                                        <TextField // Note KP : TextFieldNombre en cours de test
                                            label="Taux effectif global annuel maximum"
                                            disabled={!this.state.onActiveLesChampsDuFormulaire}
                                            required={this.state.onActiveLesChampsDuFormulaire}
                                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'financement', 'tauxEffectifGlobalAnnuelMax', false, 3)}
                                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'financement', 'tauxEffectifGlobalAnnuelMax', this._onVerificationFormulaire)}
                                            onBlur={e => this._onMiseAJourChampNombre("financement", "tauxEffectifGlobalAnnuelMax", e.target.value, this._onVerificationFormulaire)}
                                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'tauxEffectifGlobalAnnuelMax', e, false, 3)}
                                            deferredValidationTime={0}
                                            suffix="% par an"
                                        />
                                    </div>)
                                    :
                                    (<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6 ms-xxl6 ms-xxxl6" name="divTaux">
                                        <TextField
                                            label="Taux effectif global annuel maximum"
                                            required={this.state.onActiveLesChampsDuFormulaire}
                                            disabled
                                            value="0.00"
                                            suffix="% par an"
                                        />
                                    </div>)
                                }
                            </div>
                            {/*<div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 boutonBlocFinancement">
                                    <PrimaryButton onClick={() => this._onEnregistrement()} disabled={!boutonActif} style={{ marginRight: '8px' }}>Enregistrer</PrimaryButton>
                                    <DefaultButton onClick={() => this.setState({ financement: {} })}>Annuler</DefaultButton>
                                </div>
                            </div>*/}
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            {<DetailsList
                                items={this.state.listFinancements}
                                columns={this.columns}
                                selectionMode={SelectionMode.none}
                            />}
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        //#region chargement des columns
        let columnsTemp = [];

        if (this.props.peutModifierBlocFinancement) {
            columnsTemp.push({
                key: 'naturePret',
                name: 'Nature du prêt',
                fieldName: 'naturePret',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                onRender: (item) => {
                    return <span className="labelFinancement" onClick={() => this.setState({ financement: item, onActiveLesChampsDuFormulaire: true }, this._onVerificationFormulaire)}>{item.naturePret}</span>;
                }
            });
        }
        else {
            columnsTemp.push({
                key: 'naturePret',
                name: 'Nature du prêt',
                fieldName: 'naturePret',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                onRender: (item) => {
                    return <span>{item.naturePret}</span>;
                }
            });
        }

        columnsTemp.push({
            key: 'montantTotalMax',
            name: 'Montant total maximum',
            fieldName: 'montantTotalMax',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            onRender: (item) => {
                return (item.montantTotalMax !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.montantTotalMax, false, 2)} €</span> : null);
            }
        });
        columnsTemp.push({
            key: 'dureeMinimale',
            name: 'Durée minimale en années',
            fieldName: 'dureeMinimale',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return (item.dureeMinimale !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.dureeMinimale, false, 0)} ans</span> : null);
            }
        });
        columnsTemp.push({
            key: 'tauxEffectifGlobalAnnuelMax',
            name: 'Taux effectif global annuel maximum (% par an)',
            fieldName: 'tauxEffectifGlobalAnnuelMax',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return (item.tauxEffectifGlobalAnnuelMax !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.tauxEffectifGlobalAnnuelMax, false, 3)} %</span> : null);
            }
        });

        if (this.props.peutSupprimerBlocFinancement) {
            columnsTemp.push({
                key: 'suppression',
                name: '',
                ariaLabel: 'Suppression du financement',
                fieldName: 'suppression',
                minWidth: 20,
                maxWidth: 20,
                iconName: '',
                isIconOnly: true,
                isSorted: false,
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        title="Supprimer"
                        ariaLabel="Suppression"
                        onClick={() => this._onSuppression(item.idFinancement)} />;
                }
            });
        }

        this.columns = columnsTemp;
        //#endregion

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onChargement(chargementInitial) {
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);

        if (chargementInitial) {
            if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent) {
                this._chargementDonnees();
            }
        }
        else {
            if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent && !this.state.enCoursDeTraitement) {
                this._chargementDonnees();
            }
        }
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du financement'
        });

        let chargementFinancement = DataFinancement._chargementFinancement(this.props.idOperation, this.props.idReservation);

        chargementFinancement
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = {};
                    //stateTemp.idReservation = this.props.idReservation;
                    //stateTemp.idOperation = this.props.idOperation;
                    stateTemp.financement = {
                        idReservation: this.props.idReservation,
                        idOperation: this.props.idOperation
                    };
                    //stateTemp.peutModifierBlocFinancement = this.props.peutModifierBlocFinancement;

                    stateTemp.listFinancements = objetData;
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du financement'
        });

        let onEnregistrementFinancement = DataFinancement._onEnregistrementFinancement(this.state.financement);

        onEnregistrementFinancement
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onSuppression(idFinancement) {
        if (window.confirm("Voulez-vous supprimer ce financement ?")) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Suppression du financement'
            });

            let onSuppressionFinancement = DataFinancement._onSuppressionFinancement(idFinancement);

            onSuppressionFinancement
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        this._chargementDonnees();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onVerificationFormulaire() {
        //MG: 2367
        if (this.state.financement.naturePret === "PTZ") {
            const tauxEffectifGlobalAnnuelMax = 0.00;
            this.setState(prevState => ({
                financement: { ...prevState.financement, tauxEffectifGlobalAnnuelMax },
            }));
        }

        Immocom.fiche()._validationFormulaire(this, 'Financement', this.state.financement, (this.state.financement.idFinancement > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton name="btnEnregistrerFinance" onClick={() => this._onEnregistrement()} style={{ marginRight: '8px' }} disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
                <DefaultButton name="btnCancelFinance" onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
    }

    _onMiseAJourChampNombre = (nomObjet, nomPropriete, valeur) => {
        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, nomObjet, nomPropriete, valeur, 'fr', this._onVerificationFormulaire);
    }

    _onOpen = () => {
        if (!this.state.enCoursDeTraitement)
            this._chargementDonnees();
    }

    componentDidMount() {

    }

    componentDidUpdate() { }

    render() {
        return this._creationContent();
    }
}